module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "不续费原因"
    },
    model: {
      value: (_vm.visibleThis),
      callback: function($$v) {
        _vm.visibleThis = $$v
      },
      expression: "visibleThis"
    }
  }, [_c('Form', {
    ref: "editSalaryForm",
    staticClass: "form",
    attrs: {
      "label-width": 80,
      "complaintRow": _vm.attendanceRowThis,
      "model": _vm.attendanceRowThis
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Row', [_c('Form-item', {
    attrs: {
      "label": "学生信息"
    }
  }, [_c('Input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.attendanceRowThis.nickname),
      callback: function($$v) {
        _vm.$set(_vm.attendanceRowThis, "nickname", $$v)
      },
      expression: "attendanceRowThis.nickname"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Row', [_c('Form-item', {
    attrs: {
      "label": "一级原因"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.attendanceRowThis.remark),
      callback: function($$v) {
        _vm.$set(_vm.attendanceRowThis, "remark", $$v)
      },
      expression: "attendanceRowThis.remark"
    }
  }, _vm._l((_vm.$constant.stdOverRemark), function(item) {
    return _c('Option', {
      key: item.text,
      attrs: {
        "value": item.text
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Row', [_c('Form-item', {
    attrs: {
      "label": "其他原因"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.attendanceRowThis.remarkExt),
      callback: function($$v) {
        _vm.$set(_vm.attendanceRowThis, "remarkExt", $$v)
      },
      expression: "attendanceRowThis.remarkExt"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Row', [_c('Form-item', {
    attrs: {
      "label": "附件图片"
    }
  }, [_c('multipleImageUpload', {
    attrs: {
      "defaultFileList": _vm.attachmentFileList,
      "text": "点击上传附件图片",
      "num": 5
    },
    on: {
      "on-file-change": _vm.handleAttachmentChange
    },
    model: {
      value: (_vm.attendanceRowThis.attachmentUrls),
      callback: function($$v) {
        _vm.$set(_vm.attendanceRowThis, "attachmentUrls", $$v)
      },
      expression: "attendanceRowThis.attachmentUrls"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visibleThis = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingEditSalary
    },
    on: {
      "click": _vm.editSalary
    }
  }, [_vm._v("\n      保存\n    ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74ebe38c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/modal/EditOverRemarkModal.vue
// module id = 1887
// module chunks = 8